import { render } from "./FeederPrintLegendA3.vue?vue&type=template&id=471ae281&scoped=true"
import script from "./FeederPrintLegendA3.vue?vue&type=script&lang=js"
export * from "./FeederPrintLegendA3.vue?vue&type=script&lang=js"

import "./FeederPrintLegendA3.vue?vue&type=style&index=0&id=471ae281&lang=css"
import "./FeederPrintLegendA3.vue?vue&type=style&index=1&id=471ae281&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-471ae281"

export default script